import { useState } from "react";
import { PropTypes } from 'prop-types'
import { Accordion, AccordionTab } from "primereact/accordion";

function AccordionComp({ title, children, onTabOpen, onVal,showHideTitle=true,className }) {
	const [active, setActive] = useState([0]);
	const [active2, setActive2] = useState([]);

	console.log(onVal)
	return (
		<Accordion className={className && className} multiple expandIcon='d-none' collapseIcon='d-none' activeIndex={onVal ? active2 : active} onTabChange={(e) => onVal ? setActive2(e.index) : setActive(e.index)} onTabOpen={onTabOpen}>
			<AccordionTab
				headerTemplate={
					<div className='accordion-header'>
						<h3 className='accordion-header-title'>{title}</h3>

						{showHideTitle && (onVal && active.length > 0 ? <div className='text-primary'>Göster</div> : <div className='text-primary'>Gizle</div>)}

					</div>
				}
			>
				{children}
			</AccordionTab>
		</Accordion>
	);
}
AccordionComp.propTypes = {
	title: PropTypes.string,
	onTabOpen: PropTypes.func,
	children: PropTypes.node
}
export default AccordionComp;
